module.exports = __webpack_public_path__ + "static/media/Yaumi Kids.bab8dc62.png";